import Icon from '@/components/ui/AppIcon';

interface Benefit {
  id: number;
  icon: string;
  title: string;
  description: string;
}

const benefits: Benefit[] = [
  {
    id: 1,
    icon: 'CurrencyDollarIcon',
    title: 'Salaire Compétitif',
    description: 'Rémunération attractive de CHF 22-28/heure selon l\'expérience, avec primes de performance trimestrielles'
  },
  {
    id: 2,
    icon: 'ClockIcon',
    title: 'Horaires Flexibles',
    description: 'Planification adaptée à votre vie personnelle avec options de temps partiel et temps plein disponibles'
  },
  {
    id: 3,
    icon: 'AcademicCapIcon',
    title: 'Formation Continue',
    description: 'Programmes de formation professionnelle et certifications aux standards suisses de nettoyage'
  },
  {
    id: 4,
    icon: 'HeartIcon',
    title: 'Assurance Santé',
    description: 'Couverture médicale complète pour vous et votre famille, incluant soins dentaires et optiques'
  },
  {
    id: 5,
    icon: 'TrophyIcon',
    title: 'Reconnaissance',
    description: 'Programme de récompenses mensuelles et reconnaissance des employés exceptionnels'
  },
  {
    id: 6,
    icon: 'UserGroupIcon',
    title: 'Équipe Solidaire',
    description: 'Environnement de travail positif avec équipe multiculturelle et management bienveillant'
  },
  {
    id: 7,
    icon: 'CalendarIcon',
    title: 'Congés Payés',
    description: '25 jours de vacances annuelles plus jours fériés suisses et congés maladie'
  },
  {
    id: 8,
    icon: 'ChartBarIcon',
    title: 'Évolution Carrière',
    description: 'Parcours professionnel clair avec possibilités de devenir superviseur ou chef d\'équipe'
  }
];

interface BenefitsSectionProps {
  className?: string;
}

const BenefitsSection = ({ className = '' }: BenefitsSectionProps) => {
  return (
    <section className={`py-16 lg:py-24 bg-background ${className}`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Avantages & Bénéfices
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Nous valorisons nos employés et offrons un package complet d'avantages pour assurer votre bien-être et votre développement professionnel
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.id}
              className="bg-card p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-border"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <Icon name={benefit.icon as any} size={24} className="text-primary" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;